module.exports = __webpack_public_path__ + "media/images/common/pagetop_btn-002861cf84a4674292e9cc49f44c30bc.gif";